module.exports = __webpack_public_path__ + "static/media/default_user.437e1549.svg";